import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import site, { withBase } from "../../siteInfo";

const links = [
  ["home", "Home"],
  ["about", "About"],
  ["services", "Services"],
  ["doctors", "Doctors"],
  ["guides", "Health guides"],
  ["gallery", "Gallery"],
  ["faq", "Questions"],
  ["visit", "Visit"],
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const close = () => setOpen(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const items = links.map(([id, label]) => (
    <a key={id} href={`#${id}`} onClick={close}>
      {label}
    </a>
  ));

  return (
    <>
      <a className="skip" href="#main">
        Skip to content
      </a>
      <div className="topbar">
        <div className="topbar-inner">
          <span>{site.address}</span>
          <span className="topbar-meta">
            <span>{site.hours}</span>
            <a href={`tel:${site.phoneTel}`}>{site.phoneDisplay}</a>
            <a href={`tel:${site.phoneAltTel}`}>{site.phoneAltDisplay}</a>
          </span>
        </div>
      </div>
      <header className={scrolled ? "nav nav-scrolled" : "nav"}>
        <div className="nav-inner">
          <a className="brand" href="#home" onClick={close}>
            <img src={withBase("/logo.png")} alt="" />
            <span>
              <strong>Rao Lokram Charitable Trust</strong>
              <span>Hospital · Kadipur Road</span>
            </span>
          </a>
          <button
            className="menu-toggle"
            type="button"
            aria-expanded={open}
            aria-controls="site-menu"
            onClick={() => setOpen((v) => !v)}
          >
            {open ? "Close" : "Menu"}
          </button>
          <nav className="menu menu-desktop" aria-label="Primary">
            {items}
            <a
              className="nav-call"
              href={`tel:${site.phoneTel}`}
              aria-label={`Call the hospital desk at ${site.phoneDisplay}`}
            >
              Call the desk
            </a>
          </nav>
          <AnimatePresence>
            {open && (
              <motion.nav
                id="site-menu"
                className="menu menu-sheet"
                aria-label="Primary"
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -8 }}
                transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
              >
                {items}
                <a
                  className="nav-call"
                  href={`tel:${site.phoneTel}`}
                  onClick={close}
                  aria-label={`Call the hospital desk at ${site.phoneDisplay}`}
                >
                  Call the desk
                </a>
              </motion.nav>
            )}
          </AnimatePresence>
        </div>
      </header>
    </>
  );
};

export default Navbar;
